export function buttonActionFunc() {
  let resizecheck = $('#responsibleCheck').width();

  window.addEventListener('resize', () => {
    resizecheck = $('#responsibleCheck').width();
  }, false);

  //SP版フッターアコーディオン処理
  $('.aCd').on('click', function () {
    if (resizecheck == '2') {
      if ($(this).hasClass('open')) {
        $(this).next('dd').slideUp(500);
        $(this).removeClass('open');
      } else {
        $('.aCd').next('dd').slideUp(500);
        $('.aCd').removeClass('open');
        $(this).next('dd').slideDown(500);
        $(this).addClass('open');
      }
    }
  });

  //言語選択
    $('#jsLang').find('dt').on('click', function () {
      $(this).toggleClass('open');
      $(this).next().stop().slideToggle(500);
    });
}
export function lagActionFunc() {
  //マウスを乗せたら発動
  $('#jsLang').hover(function () {
    $(this).find('dt').addClass('open');
    $(this).find('dd').stop().slideDown(500);

    //ここにはマウスを離したときの動作を記述
  }, function () {
    $(this).find('dt').removeClass('open');
    $(this).find('dd').stop().slideUp(500);
  });
}